import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_9e6f6x9c2j: FaireBrandEntity = {
  token: "b_9e6f6x9c2j",
  type: "brand",
  name: "Kidpik",
  avatarUrl:
    "https://cdn.faire.com/fastly/6331b180b71551e933df312295f7172a64f256c32bdfd98059232e317ca54c2b.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/78f385d463887a0dfbfce5923f410c1bff7fc1b0ed99293b2bab599161d1a6e5.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/6331b180b71551e933df312295f7172a64f256c32bdfd98059232e317ca54c2b.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/78f385d463887a0dfbfce5923f410c1bff7fc1b0ed99293b2bab599161d1a6e5.jpeg",
  location: "New York, NY, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 5,
  isInsider: true,
  description:
    "kidpik was founded in 2016 in NYC by Ezra Dabah and his team, existing of parents, creatives, and stylists who have over three decades of childrenswear experience and previously built a multi-billion-dollar children's specialty store. Together, they set out to deliver a solution for parents by delivering a fashion clothing box with personalized and stylized outfits for their kids. With kidpik, parents trade the difficulty of shopping for their kids with the excitement of unboxing a curated surprise from the comfort of their home.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:04.229Z",
    importedBy: "entity-db-cli",
  },
};
